angular.module('iqxCore')
.controller('CandidateDownloadsCtrl', function ($scope, FormSvc, ApiSvc, $http, ApplicationSvc, $location) {

  if ($scope.userHasRight('CANDHIDEDOWNLOADSPAG')) {
    $location.url('/noPermission')
  }

	FormSvc.setOptions($scope,{
		fetchAPI:'callresult/NetStandardDocumentList',
		multiRow:true,
		doNotPreventNav:true
	})


	$scope.showDocument=function(doc) {
		var x
		if(doc.DocumentDescription.indexOf('.'+doc.DocumentExtension) > -1){
			x = encodeURIComponent(doc.DocumentDescription)
		} else {
			x = encodeURIComponent(doc.DocumentDescription+'.'+doc.DocumentExtension)
		}
		
		if ($scope.isApp !== true && $scope.isWebView !== true){
			var _newTab = window.open('about:blank', '_blank')
		}
		doc.downloadError=''
		$http.get('/api/document/doxi',{params:{class:"G",id:doc.DocumentID,ext:doc.DocumentExtension}})
		.then(function(res) {
			setTimeout(function () { // wait a second then fill that blank tab - thus stopping that pesky popup blocker!!
				if ($scope.isApp !== true && $scope.isWebView !== true){
					_newTab.location.href = '/api/document/download?doxi='+res.data+'&filename='+x
				} else {
					window.open('/api/document/download?doxi='+res.data+'&filename='+x, '_blank')
				}
			}, 100)
		})
		.catch(function(err) {
			doc.downloadError=ApiSvc.ExtractError(err)
		})
	}

	$scope.fetch()
})
